import mime from "mime";
import extension from "@local/extensions/utilities/extension.js";
import nameMinusExtension from "@local/extensions/utilities/name-minus-extension.js";
import imgClipToBase64 from "#src/extensions/dom/img-clip-to-base64.js";
import dataUrlToBase64 from "#src/extensions/data-url-to-base64.js";
import { api } from "#src/api";
import { settingTriopsUrl as triopsUrl } from "#src/stores/ui.js";

let $triopsUrl;
triopsUrl.subscribe((v) => ($triopsUrl = v));

async function clipImage(page, clip) {
  const ext = extension(page.name);
  if (ext === "pdf") {
    const path = encodeURIComponent(
      `${nameMinusExtension(page.name)}.${page.page}.tiff`,
    );
    const { x, y, width: w, height: h } = clip;
    const cpath = `${x},${y},${w},${h}`;
    const url = `${$triopsUrl}/iiif/2/drawings/${path}/${cpath}/full/0/default.jpg`;

    // if (new URL($triopsUrl).hostname !== "localhost") {
    //   return {
    //     type: "base64",
    //     media_type: "image/jpeg",
    //     url,
    //     clip,
    //     path,
    //     original_extension: ext,
    //   };
    // }

    const img = await fetch(url);
    const buf = await img.arrayBuffer();
    const base64 = btoa(
      new Uint8Array(buf).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        "",
      ),
    );
    return {
      type: "base64",
      media_type: "image/jpeg",
      url,
      clip,
      path,
      data: base64,
      original_extension: ext,
    };
  } else {
    const res = await api.storage
      .from("documents")
      .createSignedUrl(page.name, 60);
    if (res.error) return null;
    const url = res.data.signedUrl;
    // imgClipToBase64 returns a data URL because its other callers use it
    // directly as an <img src>. See data-url-to-base64.js for why the media
    // type comes from that URL rather than from `ext`.
    const { data, mediaType } = dataUrlToBase64(
      await imgClipToBase64(url, clip),
    );
    return {
      type: "base64",
      media_type: mediaType || mime.getType(ext) || "image/jpeg",
      data,
      url,
      clip,
      original_extension: ext,
    };
  }
}

async function locationImage(location, grp) {
  const clip = location.clip;
  const doc = grp.documents[location.document_id];
  const page = doc.data.pages[location.page_id];
  if (!page) return null;

  return await clipImage(page, clip);
}

export default locationImage;

export { clipImage, locationImage };
